import styled from 'styled-components';
import { color, font, mixin } from 'shared/utils/styles';
import { InputDebounced, Spinner, Icon } from '../../../../shared';
import { Button, lightenDarkenColor } from '../../shared/utils/styles';

export const ItemSearch = styled.div`
  padding: 25px 35px 60px 20px;
`;

export const SearchInputCont = styled.div`
  position: relative;
  padding-right: 30px;
  margin-bottom: 30px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 0 0 32px;
  border: none;
  border-bottom: 2px solid ${color.primary};
  background: #fff;
  ${font.size(1)}
  &:focus,
    &:hover {
    box-shadow: none;
    border: none;
    border-bottom: 2px solid ${color.primary};
    background: #fff;
  }
`;

export const SearchInputDebounced = styled(InputDebounced)`
  height: 40px;
  input {
    padding: 0 0 0 32px;
    border: none;
    border-bottom: 2px solid ${color.primary};
    background: #fff;
    ${font.size(1)}
    &:focus,
    &:hover {
      box-shadow: none;
      border: none;
      border-bottom: 2px solid ${color.primary};
      background: #fff;
    }
  }
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  top: 8px;
  left: 0;
  color: ${color.textMedium};
`;

export const SearchSpinner = styled(Spinner)`
  position: absolute;
  top: 5px;
  right: 30px;
`;

export const InstructionContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  & i {
    font-size: 1.5em;
  }
`;

export const Instruction = styled.div`
  padding: 0px 10px;
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 4px;
  margin: 3px 0px;
  border-radius: 4px;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.color};
  ${mixin.clickable}
  &:hover {
    padding: 4px 8px;
    background-color: ${(props) => lightenDarkenColor(props.bgColor, props.hoverVariance)};
    color: ${(props) => props.color};
    overflow-x: hidden;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }  
  & img {
    width: auto;
    height: 50px;
  }
  & i {
    font-size: 1.5em;
    padding-right: 5px;
    ${(props) => (props.closed ? 'color: #21BA45;' : 'color: gray;')}
    color: ${(props) => props.color ?? '#666'};
  }
`;

export const ItemListContainer = styled.div`
  position: absolute;
  width: 325px;
  top: 220px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
`;

export const ItemList = styled.div`
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const ItemData = styled.div`
  padding-left: 5px;
  padding-right: 5px;
`;

export const ItemTitle = styled.div`
  color: ${(props) => props.color};
  ${font.size(0.85)}
`;

export const ItemTypeId = styled.div`
  text-transform: uppercase;
  color: ${color.textMedium};
  ${font.size(1)}
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  text-transform: uppercase;
  color: ${color.textMedium};

  ${font.bold}
  ${font.size(1)}
`;

export const NoResults = styled.div`
  padding-top: 50px;
  text-align: center;
`;

export const NoResultsTitle = styled.div`
  padding-top: 30px;
  ${font.medium}
  ${font.size(1)}
`;

export const NoResultsTip = styled.div`
  padding-top: 10px;
  ${font.size(1)}
`;

export const FilterButton = styled(Button)`
  height: 2em;
  font-size: 0.8em;
  padding: 2px 4px;
  text-transform: none;
  font-weight: normal;
`;

export const FilterButtonContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-evenly;
  margin-top: 20px;
  padding-bottom: 5px;
`;
